<template>
  <div class="title title-mb">
    <div class="title-block">
      <div class="block"></div>
      <div class="titleText">{{ title }}</div>
    </div>
    <div>
      <slot name="right"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DetailTitle',
  props: {
    title: {
      type: String,
      require: true,
    }
  }
}
</script>
<style scoped lang="less">
@import '~@/assets/form.less';
</style>